Controller = App.loadClass 'core::Angular/Controller'

class exports.AdminHeaderController extends Controller
    constructor: (@scope, @state, @http, @window, @session) ->
        @scope.isOpen = false
        @scope.barVisible = true

        @scope.displayedCollection = []
        @scope.users = []
        @scope.selectedUser = null

        @scope.toggle = @toggle
        @scope.close = @close
        @scope.masquerade = @masquerade
        @scope.stopMasquerading = @stopMasquerading
        @scope.masqueradePipe = @masqueradePipe
        @scope.searchMasqueradeUsers = @searchMasqueradeUsers
        @scope.handleKeyup = @handleKeyup
        @scope.session = @session

        # Backtick (toggle open / close)
        @scope.$on 'keypress:96', (event, keypressEvent) =>
            keypressEvent.preventDefault()

            @scope.barVisible = true
            @toggle()

        # Tilde (toggle visible / invisible)
        @scope.$on 'keypress:126', (event, keypressEvent) =>
            keypressEvent.preventDefault()

            @scope.barVisible = not @scope.barVisible
            @close() if not @scope.barVisible

        # Enter
        @scope.$on 'keypress:13', (event, keypressEvent) =>
            return if not @scope.isOpen
            @masquerade @scope.selectedUser

    handleKeyup: (event) =>
        switch event.which

            # Up arrow
            when 38
                index = @scope.displayedCollection.indexOf @scope.selectedUser

                if index > 0
                    @scope.selectedUser = @scope.displayedCollection[index - 1]

            # Down arrow
            when 40
                index = @scope.displayedCollection.indexOf @scope.selectedUser

                if index < @scope.displayedCollection.length - 1
                    @scope.selectedUser = @scope.displayedCollection[index + 1]


    masqueradePipe: (tableState) =>
        @http.post 'backend/session-mgmt/get-masquerade-users',
            searchText: tableState.search?.predicateObject?.$ or ''
            start: tableState.pagination.start
            number: tableState.pagination.number
            app: @state.$current.name.split('.')[0]
        .then (response) =>
            @scope.displayedCollection = response.data.users
            @scope.selectedUser = @scope.displayedCollection[0] if @scope.displayedCollection.length

            if response.data.total is 0
                tableState.pagination.numberOfPages = 0
            else
                tableState.pagination.numberOfPages = response.data.total / tableState.pagination.number

    toggle: () =>
        @scope.isOpen = not @scope.isOpen

    open: () =>
        @toggle() if not @scope.isOpen

    close: () =>
        @toggle() if @scope.isOpen

    masquerade: (user) =>
        # During the saifsa survey, when the user tries to masquerade and then clicks cancel (stay on page) on the dialog, a problem
        # occurs because the user has been masqueraded, but the the page is not reloaded. To prevent this problem, the following check
        # will not allow a user to masquerade during the survey.
        if @state.$current.name is 'grower.declarations.saifsa'
            console.error 'Go back to the declarations page before masquerading'
            return

        @http.post "#{Config.get('api_url')}/masquerade-token",
            userId: user.id
        .then (response) =>

            token = response.data.token

            @session.set 'Authorization', "Bearer #{token}"
            @session.set 'SafeLink', "Bearer #{token}"
            # When masquerading, set both the portal and grower company
            # because some portal routes rely on the grower company and these can get out of sync otherwise
            @session.set 'SelectedCompany-grower', user.company
            @session.set 'SelectedCompany-portal', user.company

            # Eventually when LITERALLY EVERYTHING is angularized, we may be able to get away
            # with simply reloading the state rather than the whole page. Unfortunately,
            # we still inject lots of things into the HTML via the blade templates, so
            # we still have to reload the page.
            #
            # Note: When everything *is* angularized, we will want to replace the reload call
            # with `Socket.socket.send user.id` so that the websocket (which won't get
            # reopened at that point) will be associated with the correct user.
            #
            # Another thing we'll want to do if we take this out is to set the masqueraded
            # user in Raven's user context so it gets reported to Sentry:
            # Raven?.setUserContext Raven?.getContext().user.extend { masquerade: data }
            # or something like that.
            @window.location.reload()

    stopMasquerading: () =>
        if @state.$current.name is 'grower.declarations.saifsa'
            console.error 'Go back to the declarations page before masquerading'
            return

        app = @state.$current.name.split('.')[0]
        @session.set 'Authorization', @session.get('OriginalUser')
        @session.set 'SafeLink', @session.get('OriginalUser')
        @session.set 'SelectedCompany-grower', 'Myfarms'
        @session.set 'SelectedCompany-portal', 'Myfarms'
        @window.location.reload()
